import { HttpError } from '@analyzer/client';
import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';

function handleAuthError(error: unknown) {
  if (error instanceof HttpError && error.status === 401) {
    window.dispatchEvent(new CustomEvent('auth:expired'));
  }
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60000,
      retry: (failureCount, error) => {
        if (error instanceof HttpError && error.status === 401) return false;
        return failureCount < 3;
      }
    }
  },
  queryCache: new QueryCache({ onError: handleAuthError }),
  mutationCache: new MutationCache({ onError: handleAuthError })
});
